import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from '../../../common/components/runtime-context';
import classNames from 'classnames';
import SearchButton from '../search-button';
import { getCategoryBySlug } from '../../../common/selectors/categories-selectors';
import withTranslate from '../../../common/components/with-translate/with-translate';
import withAuth from '../../hoc/with-auth';
import withLayoutType from '../../hoc/with-layout-type';
import withPermissions from '../../hoc/with-permissions';
import styles from './header-buttons.scss';
import { MODAL_TYPE_FORUM_ACTIONS } from '../modals/action-sheet/action-sheet-modal-types';
import MoreButtonMobile from '../more-button-mobile/more-button-mobile';
import { getPostBySlug } from '../../selectors/post-selectors';
import { REDUCERS } from '../../../common/components/runtime-context/reducers';
import CurrentUserAvatarImage from '../../containers/current-user-avatar-image';
import AvatarImage from '../avatar-image';
import { getIsLoginWidgetEnabled } from '../../selectors/app-settings-selectors';

export const HeaderButtons = ({
  isAuthenticated,
  isInPost,
  category = {},
  post,
  can,
  loginMember,
  buttonClicked,
  isLoginWidgetEnabled,
}) => (
  <div className={classNames(styles.container, 'header-buttons')}>
    <div className={styles.searchButtonSpacing} data-hook="search-button">
      <SearchButton />
    </div>
    {isLoginWidgetEnabled
      ? renderActions({
          isAuthenticated,
          category,
          can,
          isInPost,
          post,
          loginMember,
          buttonClicked,
        })
      : null}
  </div>
);

function renderActions({ isAuthenticated, category, post, loginMember, buttonClicked }) {
  return (
    <div className={classNames(styles.actions, styles.actionsContainer, 'forum-icon-fill')}>
      {!isAuthenticated ? (
        <div
          data-hook="user-menu-button"
          onClick={() => {
            buttonClicked({ action: 'login' });
            loginMember();
          }}
        >
          <CurrentUserAvatarImage type={AvatarImage.SMALL} />
        </div>
      ) : (
        <MoreButtonMobile
          dataHook="user-menu-button"
          Icon={() => <CurrentUserAvatarImage type={AvatarImage.SMALL} />}
          type={MODAL_TYPE_FORUM_ACTIONS}
          category={category}
          post={post}
        />
      )}
    </div>
  );
}

HeaderButtons.propTypes = {
  currentUser: PropTypes.object,
  t: PropTypes.func,
  params: PropTypes.object.isRequired,
  category: PropTypes.object,
  post: PropTypes.object,
  canRender: PropTypes.func.isRequired,
  isInPost: PropTypes.bool.isRequired,
  isLoginWidgetEnabled: PropTypes.bool,
};

const mapRuntimeToProps = (state, ownProps, actions, host) => ({
  isInPost: ownProps.params.postSlug !== undefined,
  loginMember: actions.requestLogin,
  buttonClicked: actions.buttonClicked,
  post: getPostBySlug(state, ownProps.params.postSlug),
  isLoginWidgetEnabled: getIsLoginWidgetEnabled(state, host.style),
  category: ownProps.params.categorySlug
    ? getCategoryBySlug(state, ownProps.params.categorySlug)
    : {},
});

export default flowRight(
  connect(mapRuntimeToProps, [REDUCERS.POSTS, REDUCERS.CATEGORIES]),
  withAuth,
  withTranslate,
  withLayoutType,
  withPermissions,
)(HeaderButtons);
